/**
 * @file 网络请求相关接口
 */

import axios from "./http";


import * as tools from '@/utils/tools.js';

import * as constant from '@/utils/constant.js';


let baseUrl = "";
/**
 * @description 编辑商品时显示在页面上的数据
 * @param {Number} goodsId 商品id
*/
export async function goodsDetailApi(that, goodsId) {

    const result = await axios({
        url: `${baseUrl}/syapi/goods/goods_detail`,
        params: {
            goods_id: goodsId
        }
    });

    console.log('/syapi/goods/goods_detail result', result);

    if (that.checkApiSuccessfulFn(result)) {

        return {
            goodsId,
            // 商品名称
            name: tools.objectGetString(result, 'data.detail.goods_name'),

            // 商品分类
            classify: (() => {
                const id1 = tools.objectGetNum(result, 'data.detail.cat_id'),
                    id2 = tools.objectGetNum(result, 'data.detail.cat_id_2'),
                    ids = [id1, id2],
                    id3 = tools.objectGetNum(result, 'data.detail.cat_id_3');

                if (id3) {
                    ids.push(id3);
                }
                return ids;
            })(),

            // 计量方式0 称重 1计件
            measureType: tools.objectGetNum(result, 'data.detail.is_scantling'),

            // 重量单位 1:g  2:kg
            weight_type: tools.objectGetNum(result, 'data.detail.weight_type'),

            // 商品单位
            unit: tools.objectGetString(result, 'data.detail.unit'),


            // 售价
            price: tools.objectGetDoubleNum(result, 'data.detail.desk_price'),


            // 条形码
            goods_barcode: tools.objectGetString(result, 'data.detail.goods_barcode'),

            // 会员折扣
            discount: (() => {
                const num = tools.objectGetDoubleNum(result, 'data.detail.desk_vip_discount');
                return num ? num : '';
            })(),

            // 库存数量
            num: (() => {
                const count = tools.objectGetDoubleNum(result, 'data.detail.store_count'),
                    dot = tools.objectGetDoubleNum(result, 'data.detail.store_count_dot');
                return tools.bigPlus(count, dot);
            })(),

            // 上传图片
            imageUrl: tools.objectGetString(result, 'data.detail.original_img'),

        }



    }
    return result
}




/**
 * @description 获取基础设置数据
*/
export async function configApi(that) {

    // const result = await axios({
    //     url: `${baseUrl}/syapi/config/baseic`,
    // });

    // console.log('/syapi/config/baseic result', result);

    // if (that.checkApiSuccessfulFn(result)) {
    //     const config = {};
    //     tools.objectGetArray(result, 'data').forEach(i => {
    //         // 显示单位 2:公斤; 3:斤
    //         if (i.name == 'desk_weight_type') {
    //             let val = constant.unitType.kg;
    //             if (i.value == 3) {
    //                 val = constant.unitType.jin;
    //             }
    //             config.showUnitType = val;
    //         }
    //     })

    //     return config
    // }
    // return result
}



/**
 * @description 保存显示单位类型
*/
export async function saveUnitTypeApi(that, value) {

    const result = await axios({
        method: 'post',
        url: `${baseUrl}/syapi/config/weightTypeSave`,

        data: {
            desk_weight_type: value
        }

    });

    console.log('/syapi/config/weightTypeSave result', result);

    return result
}


export async function getRules() {

    const result = await axios({
        method: 'post',
        url: `${baseUrl}/syapi/config/getRules`,
    });
    return result
}


export async function print_history() {
	// alert(window.Android.dConnectedDeviceName())
	// alert(window.Android.dConnectedDeviceId())

    const result = await axios({
        method: 'post',
				params: {
				    use_printer_name: window.Android.dConnectedDeviceName(),
				    use_printer_id: window.Android.dConnectedDeviceId(),
				     // use_printer_type: goodsId,
				},
        url: `${baseUrl}/syapi/config/print_history`,
    });
    return result
}



// WEBPACK FOOTER //
// ./src/api/apis.js